import { Injectable } from '@angular/core';
import { ParseService } from '../parse/parse.service';
import Speech from 'speak-tts';


@Injectable({
    providedIn: 'root'
})

export class TextToSpeechService {

    html = '';
    result = '';
    speech: any;
    speechData: any;

    constructor(private parseService: ParseService,

    ) {

        this.speech = new Speech() // will throw an exception if not browser supported
        if (this.speech.hasBrowserSupport()) { // returns a boolean
            // console.log("speech synthesis supported");
            this.speech.init({
                'volume': 1,
                'lang': 'en-GB',
                'rate': 1,
                'pitch': 1,
                'voice': 'Google UK English Male',
                'splitSentences': true,
                'listeners': {
                    'onvoiceschanged': (voices) => {
                        // console.log("Event voiceschanged", voices);
                    }
                }
            }).then((data) => {
                // The "data" object contains the list of available voices and the voice synthesis params
                // console.log("Speech is ready, voices are available", data);
                this.speechData = data;
                data.voices.forEach(voice => {
                    // console.log(voice.name + " " + voice.lang);
                });
            }).catch(e => {
                // console.error("An error occured while initializing : ", e);
            })
        }

    }


    async start(text) {
        this.html = 'In this era of digital transformation, next gen technologies like Artificial intelligence, machine learning, IOT can simplify, automate and speed of the tasks that we do in our day to day life. Sustaining and adapting to such technology culture will exponentially increase your business possibilities and fundamentally transforming your customer experiences.';
        var temporalDivElement = document.createElement("div");
        // Set the HTML content with the providen
        temporalDivElement.innerHTML = this.html;
        // Retrieve the text property of the element (cross-browser support)
        this.result = temporalDivElement.textContent || temporalDivElement.innerText || "";

        this.speech.speak({
            text: text,
            queue: false, // current speech will be interrupted,
            listeners: {
                onstart: () => {
                    // console.log("Start utterance");
                },
                onend: () => {
                    // console.log("End utterance");
                },
                onresume: () => {
                    // console.log("Resume utterance");
                },
                onboundary: (event) => {
                    // console.log(event.name + ' boundary reached after ' + event.elapsedTime + ' milliseconds.');
                }
            }
        }).then(() => {
            // console.log("Success !");
        }).catch(e => {
            // console.error("An error occurred :", e);
        })

    }

    pause() {
        this.speech.pause();
    }

    resume() {
        this.speech.resume();
    }

    setLanguage(i) {
        // console.log(i);
        // console.log(this.speechData.voices[i].lang + this.speechData.voices[i].name);
        this.speech.setLanguage(this.speechData.voices[i].lang);
        this.speech.setVoice(this.speechData.voices[i].name);
    }


}